<p-floatlabel variant="on">
  <p-date-picker [formControl]="control()" [invalid]="control().invalid && control().touched" appendTo="body"
                 [minDate]="minDate() ?? undefined"
                 dateFormat="dd/mm/yy" fluid pInputMask="99/99/9999"/>
  <label for="in_label">{{ label() }}
    @if (isRequired()) {
      <span class="text-red-500">*</span>
    }</label>
</p-floatlabel>
@if (control().invalid && control().touched) {
  @if (control().hasError('required')) {
    <p-message severity="error" size="small" variant="simple">{{ 'error.required' | translate }}</p-message>
  }
  @if (control().hasError('dateBeforeLastNumbered')) {
    <p-message severity="error" size="small" variant="simple">{{ 'error.date-before-last-numbered' | translate }}</p-message>
  }
}
